import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import { Toaster } from "react-hot-toast";
import { useNotificationContext } from "../utils/NotificationContext";
import { createAxiosInstance } from "../utils/AxiosInstance";
import { useConfig } from "../utils/ConfigContext.jsx";
import { useSelector } from "react-redux";

import { requestWebPushPermission } from "../helper/webPush.js";

const Notifications = () => {
    const dropdownRef = useRef(null);
    const { notifications } = useNotificationContext();

    const unreadCount = notifications.filter(n => !n.isRead).length;
    const unreadNotifications = notifications.filter(n => !n.isRead);


    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    const userData = useSelector((state) => state.auth.userData);
    const userId = userData?.id;



    const markAllNotificationsRead = async () => {
        if (unreadCount === 0) return;

        const notifIds = unreadNotifications.map(n => n.id);  // ✅ ARRAY of IDs

        try {
            await AxiosInstance.post("/notification/mark-read", {
                user_id: userId,
                notif_ids: notifIds
            });

            console.log("Marked as read", notifIds);
        } catch (err) {
            console.error("Mark read failed", err);
        }
    };

    const subscribeForWebPush = async () => {
        try {
            const token = await requestWebPushPermission();
            if (!token) {
                console.warn("Web Push permission not granted or token not available.");
                return;
            }
            // Send the token to your backend to save it
            await AxiosInstance.post("/notification/subscribe-web-push", {
                user_id: userId,
                fcm_token: token
            });
            console.log("Web Push subscribed with token:", token);
        } catch (error) {
            console.error("Web Push subscription failed:", error);
        }
    }


    // 🔥 Fired when dropdown closes
    useEffect(() => {
        const el = dropdownRef.current;
        if (!el) return;

        const onClose = () => {
            if (unreadCount > 0) {
                markAllNotificationsRead()  // 🔥 HIT API HERE
            }
        };

        el.addEventListener("hidden.bs.dropdown", onClose);

        return () => {
            el.removeEventListener("hidden.bs.dropdown", onClose);
        };
    }, [unreadCount]);

    return (
        <>
            <style>
                {`
          @keyframes progress {
            from { width: 100%; }
            to { width: 0%; }
          }
        `}
            </style>

            <div className="dropdown" ref={dropdownRef}>
                {/* Bell Button */}
                <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                >
                    <Icon icon="iconoir:bell" className="text-primary-light text-xl" />

                    {unreadCount > 0 && (
                        <span
                            style={{
                                position: "absolute",
                                top: "-5px",
                                right: "-5px",
                                background: "red",
                                color: "#fff",
                                borderRadius: "50%",
                                width: "18px",
                                height: "18px",
                                fontSize: "11px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {unreadCount}
                        </span>
                    )}
                </button>

                {/* Dropdown List */}
                <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                    <div className="m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                        <h6 className="text-lg text-primary-light fw-semibold mb-0">
                            Notifications
                        </h6>

                        <span className="text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center">
                            {unreadCount}
                        </span>
                    </div>

                    <div className="max-h-400-px overflow-y-auto scroll-sm pe-4">
                        {notifications.length === 0 ? (
                            <p className="text-center text-secondary-light">No notifications</p>
                        ) : (
                            notifications.map((n) => {
                                const createdAt_date = n.created_at.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                });
                                const createdAt_time = n.created_at.toLocaleTimeString('en-US', {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: true,
                                });
                                
                                const packageName = n.packages && Array.isArray(n.packages) ? n.packages.join(", ") : "No Packages";

                                return (
                                    <Link
                                        to="#"
                                        key={n.id}
                                        className={`px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between ${!n.isRead ? "bg-primary-50" : ""
                                            }`}
                                    >
                                        <div className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                                            <span className="w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                                <Icon icon="bitcoin-icons:verify-outline" className="icon text-xxl" />
                                            </span>

                                            <div>
                                                <h6 className="text-md fw-semibold mb-4">{n.title}</h6>
                                                <p className="mb-0 text-sm text-secondary-light text-w-400-px">{n.center_name}</p>
                                                <p className="mb-0 text-sm text-secondary-light text-w-400-px">{n.patient_name} [{packageName}]</p>
                                            </div>
                                        </div>

                                        <span className="text-sm text-secondary-light flex-shrink-0">
                                            {createdAt_date} <br /> {createdAt_time}
                                        </span>
                                    </Link>
                                );
                            })
                        )}
                    </div>

                    <div className="text-center py-12 px-16">
                        {/* <Link to="#" className="text-primary-600 fw-semibold text-md">
                            See All Notifications
                        </Link> */}
                        <button onClick={subscribeForWebPush} className="text-primary-600 fw-semibold text-md" >Subscribe for Web Push</button>
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default Notifications;

